import { EChatWindowActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Открыть чат
 */
export const openChat = actionGenerator<EChatWindowActionTypes.OpenChat, string>(EChatWindowActionTypes.OpenChat);
export const closeChat = actionGenerator<EChatWindowActionTypes.CloseChat>(EChatWindowActionTypes.CloseChat);
export const resetChat = actionGenerator<EChatWindowActionTypes.ResetChat>(EChatWindowActionTypes.ResetChat);
export const increaseCountClosedChats = actionGenerator<EChatWindowActionTypes.IncreaseCountClosedChats>(
  EChatWindowActionTypes.IncreaseCountClosedChats,
);
